// material-ui
import { Typography } from '@mui/material';
// import useAuth from 'hooks/useAuth';
import getMenuItems from 'menu-items';
// project imports
import NavGroup from './NavGroup';

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = () => {
    // const { user } = useAuth();

    const navItems = getMenuItems(false).items.map((item) => {
        switch (item.type) {
            case 'group':
                return <NavGroup key={item.id} item={item} />;
            default:
                return (
                    <Typography key={item.id} variant="h6" color="error" align="center">
                        Menu Items Error
                    </Typography>
                );
        }
    });

    return <>{navItems}</>;
};

export default MenuList;
